import React, { useEffect, useState } from "react";
import { ENDPOINTS, authFetch } from "../../api/api";
import "../components/AdminLayout.css";

const AdminMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    authFetch(ENDPOINTS.contact_messages)
      .then(setMessages)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="adm-page-header">
        <div>
          <h1 className="adm-page-title">Contact Messages</h1>
          <p className="adm-page-sub">{messages.length} messages received</p>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: selected ? "1fr 1fr" : "1fr", gap: "1rem" }}>

        {/* Messages list */}
        <div className="adm-table-wrap">
          {loading ? (
            <div className="adm-loading"><div className="adm-loading-spinner"></div></div>
          ) : messages.length === 0 ? (
            <div className="adm-empty">
              <i className="fa-solid fa-inbox" style={{ fontSize: "2rem", color: "rgba(255,255,255,0.1)" }}></i>
              No messages yet
            </div>
          ) : (
            <table className="adm-table">
              <thead>
                <tr>
                  <th>From</th>
                  <th>Subject</th>
                  <th>Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {messages.map((m) => (
                  <tr
                    key={m.id}
                    onClick={() => setSelected(selected?.id === m.id ? null : m)}
                    style={{ cursor: "pointer", background: selected?.id === m.id ? "rgba(10,107,90,0.08)" : undefined }}
                  >
                    <td>
                      <div style={{ fontWeight: 600 }}>{m.name}</div>
                      <div style={{ fontSize: "0.75rem", color: "rgba(255,255,255,0.35)" }}>{m.email}</div>
                    </td>
                    <td style={{ fontSize: "0.85rem" }}>{m.subject || "No subject"}</td>
                    <td style={{ fontSize: "0.8rem", color: "rgba(255,255,255,0.4)" }}>
                      {m.created_at ? new Date(m.created_at).toLocaleDateString() : "—"}
                    </td>
                    <td>
                      {m.is_read
                        ? <span className="adm-badge adm-badge--gold">Read</span>
                        : <span className="adm-badge adm-badge--green">New</span>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Message detail */}
        {selected && (
          <div className="adm-card" style={{ position: "sticky", top: "5rem", height: "fit-content" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "1.25rem" }}>
              <div>
                <h3 style={{ fontFamily: "'Syne',sans-serif", fontSize: "1rem", fontWeight: 700, color: "var(--adm-text)", marginBottom: "0.25rem" }}>
                  {selected.name}
                </h3>
                <a href={`mailto:${selected.email}`} style={{ fontSize: "0.8rem", color: "var(--adm-green-bright)", textDecoration: "none" }}>
                  {selected.email}
                </a>
              </div>
              <button className="adm-modal-close" onClick={() => setSelected(null)}>
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
            {selected.subject && (
              <div style={{ marginBottom: "1rem" }}>
                <span style={{ fontSize: "0.75rem", color: "rgba(255,255,255,0.35)", textTransform: "uppercase", letterSpacing: "0.06em" }}>Subject</span>
                <p style={{ fontSize: "0.9rem", color: "var(--adm-text)", marginTop: "0.3rem" }}>{selected.subject}</p>
              </div>
            )}
            <div>
              <span style={{ fontSize: "0.75rem", color: "rgba(255,255,255,0.35)", textTransform: "uppercase", letterSpacing: "0.06em" }}>Message</span>
              <p style={{ fontSize: "0.875rem", color: "rgba(255,255,255,0.7)", marginTop: "0.5rem", lineHeight: 1.7, whiteSpace: "pre-wrap" }}>
                {selected.message}
              </p>
            </div>
            <a
              href={`mailto:${selected.email}?subject=Re: ${selected.subject || "Your message"}`}
              className="adm-add-btn"
              style={{ marginTop: "1.5rem", display: "inline-flex", textDecoration: "none" }}
            >
              <i className="fa-solid fa-reply"></i>
              Reply via Email
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminMessages;
